<script setup>

import {CURRENCIES, getCurrencies} from "@/constants.js";
import {clickOutSide as vClickOutside} from "@/vClickOutside.js";
import MaskIcon from "@/Components/MaskIcon.vue";
import {activeCurrency, onSelectCurrency} from "@/helper.js";
import {ref} from "vue";

const showCurrency = ref(false)
const hideCurrency = () => {
    if (showCurrency.value) {
        showCurrency.value = false
    }
}

</script>

<template>
    <div v-click-outside="hideCurrency" dusk="currency-switch" class="relative " @click="showCurrency = !showCurrency">
        <div class="flex gap-2 text-sm items-center group">
            <MaskIcon src="/assets/icons/rubel.svg" v-if="activeCurrency?.value === CURRENCIES.RUB" class="w-5 h-[21px] !bg-white group-hover:!bg-blue-400"/>
            <MaskIcon src="/assets/icons/usd.svg" v-else class="w-5 h-[21px] !bg-white group-hover:!bg-blue-400"/>
            <span class="cursor-pointer group-hover:text-blue-400 transition-colors leading-full">{{
                    activeCurrency?.title
                }}</span>
            <MaskIcon src="/assets/icons/arrow.svg"
                class="w-3 h-3 !bg-white group-hover:!bg-blue-400 transition-colors duration-100"/>
        </div>
        <div v-if="showCurrency" class="absolute z-10 top-10 left-1/2 -translate-x-1/2">
            <div class=" flex items-center px-2.5 bg-deep-blue">
                <ul>
                    <li class="py-1.5 hover:text-blue-400 transition-all uppercase cursor-pointer text-sm"
                        v-for="itemCurrency in getCurrencies()"
                        @click="onSelectCurrency(itemCurrency)"
                    >{{ itemCurrency.code }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
